import React, {useState} from 'react';

import {Box, Modal, Typography, useMediaQuery, useTheme} from '@mui/material';

import {v4 as uuidv4} from 'uuid';

import BackgroundComponents from 'assets/backgroundComponents';
import {useCanvasStore} from 'canvas/zustand';
import {Text} from 'components';
import {useAnalytics} from 'hooks';
import {useGroupsStore} from 'module/group/zustand';
import {usePrefsStore} from 'store';

import {useSheetStore} from './zustand';

const styles = {
    box: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: {desktop: 'auto', sm: '80%', mobile: '90%'},
        height: 'auto',
        maxHeight: '95%',
        backgroundColor: 'grey.darkest',
        border: '0',
        borderRadius: 2,
        outline: 'none',
        p: 3,
        overflowY: 'auto',
        boxSizing: 'border-box',
    },
    innerBox: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
    },
    toolBox: {
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: '10px',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        mb: 4,
    },
    titlesContainer: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        mb: 2,
    },
    optionsTitle: {
        color: 'white.main',
        fontSize: {
            mobile: '14px',
            desktop: '22px',
        },
        ml: 1,
        fontWeight: '700',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        textTransform: 'uppercase',
    },
    optionsSubtitles: {
        color: 'grey.lightest',
        fontSize: {
            mobile: '14px',
            desktop: '22px',
        },
        ml: 1,
        fontWeight: '700',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        textTransform: 'uppercase',
    },
    field: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        WebkitUserSelect: 'none !important',
        opacity: 0.95,
        position: 'relative',
        padding: 0.25,
        transition: 'all 0.25s ease-in-out',
        backgroundColor: 'grey.light',
        width: '31.333333%',
        height: 'auto',
        margin: '1%',
    }
};

const soccerFields = [{
    name: 'soccer',
    Icon: BackgroundComponents.Soccer
}, {
    name: 'soccerLandscape',
    Icon: BackgroundComponents.SoccerLandscape
}, {
    name: 'soccerThird',
    Icon: BackgroundComponents.SoccerThird
}, {
    name: 'soccerBW',
    Icon: BackgroundComponents.SoccerBW
}, {
    name: 'soccerLandscapeBW',
    Icon: BackgroundComponents.SoccerLandscapeBW
}, {
    name: 'soccerQuarterBW',
    Icon: BackgroundComponents.SoccerQuarterBW
}, {
    name: 'soccerThirdBW',
    Icon: BackgroundComponents.SoccerThirdBW
}, {
    name: 'soccerSquaresBW',
    Icon: BackgroundComponents.SoccerSquaresBW
}, {
    name: 'soccerVerticalZonesBW',
    Icon: BackgroundComponents.SoccerVerticalZonesBW
}, {
    name: 'fieldWhite',
    Icon: BackgroundComponents.FieldWhite
}];

const Field = ({name, Icon, onClick}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('desktop'));

    return <Box sx={styles.field} onClick={() => onClick(name)}>
        <Icon style={{
            width: '100%',
            height: isMobile ? '100%' : '100%',
        }}
        />
    </Box>;
};

const FieldSelector = ({sheet}) => {
    const [open, setOpen] = useState(true);

    const handleClose = () => setOpen(false);

    const updateSheet = useSheetStore((store) => store.upd);
    const setBackground = usePrefsStore((state) => state.setBackground);

    const addGroup = useGroupsStore((store) => store.add);
    const addSheet = useSheetStore((state) => state.add);
    const getByName = useGroupsStore((store) => store.getByName);

    const saveCanvas = useCanvasStore((state) => state.save);
    const setDirty = useCanvasStore(state => state.setDirty);

    const sendAnalytics = useAnalytics();

    const selectBackground = (background) => {
        
        const newId = uuidv4();
        sendAnalytics('background', background);
        setBackground(background);
       
        if (sheet) {
            updateSheet({...sheet, type: 'soccer'});
            setDirty(true);
            // saveCanvas(sheet.id, {background});
        } else {
            const groupName = 'Demo';
            addGroup({name: groupName});
            addSheet({id: newId, name: 'Demo', type: 'soccer', group: getByName(groupName).id});
            saveCanvas(newId, {background});
        }
    };

    return <Modal open={open} onClose={handleClose} disableEscapeKeyDown={true} hideBackdrop={true}>
        <Box sx={styles.box}>
            <Box sx={styles.innerBox}>
                <Box sx={styles.titlesContainer}>
                    <Typography sx={styles.optionsTitle}>
                        <Text>board.sheet.select_background</Text>
                    </Typography>
                    <Typography sx={styles.optionsSubtitles}>
                        <Text>global.soccer</Text>
                    </Typography>
                </Box>
                <Box sx={styles.toolBox}>
                    {soccerFields.map(f => <Field key={f.name} name={f.name} Icon={f.Icon} onClick={selectBackground}/>)}
                    {/*<Divider></Divider>*/}
                </Box>
            </Box>
            {/* <Box sx={styles.innerBox}>
                <Box sx={styles.titlesContainer}>
                    <Typography sx={styles.optionsTitle}>
                        <Text>board.sheet.select_background</Text>
                    </Typography>
                    <Typography sx={styles.optionsSubtitles}>
                        <Text>board.sheet.sports</Text>
                    </Typography>
                </Box>

                <Box sx={styles.toolBox}>

                    <Field
                        name="basketball"
                        Icon={BackgroundComponents.Basketball}
                        onClick={selectBackground}
                    />

                    <Field
                        name="handball"
                        Icon={BackgroundComponents.Handball}
                        onClick={selectBackground}
                    />
                    <Field
                        name="icehockey"
                        Icon={BackgroundComponents.Icehockey}
                        onClick={selectBackground}
                    />
                    <Field
                        name="americanFootball"
                        Icon={BackgroundComponents.AmericanFootball}
                        iconColor={'white.main'}
                    />

                    <Field
                        name="clear"
                        Icon={BackgroundComponents.FieldWhite}
                        onClick={selectBackground}
                    />
                </Box>
            </Box> */}
        </Box>
    </Modal>;
};

export default FieldSelector;
